
import React from "react";
import { Route, useHistory, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LoginPage from "../LoginPage";
import Layout from '../Layout';
import {useIsAuthenticated } from "@azure/msal-react";

const PrivateRoute = ({ component: Component
    , ...rest }) => {
    const history = useHistory();
    const isAuthenticated = useIsAuthenticated();
    return (
        <Route
            {...rest}
            render={props => {
                if (!isAuthenticated) {
                    return <LoginPage {...props} />;
                } else {
                    return <Layout><Component {...props} /></Layout>;
                }
            }}
        />
    );
};

export default PrivateRoute;